export default "__VITE_ASSET__YwP67BPY__"